import * as _ from 'lodash';
import * as React from "react";
import { connect } from "react-redux";
import * as Redux from "redux";
import Pusher from 'pusher-js';

import Intro from './intro';
import QuestionComponent from './question';
import TurkCodePage from './turkCodePage';

import FeedbackContainer from '../renderForQuestions/feedback';
import { Response } from '../../../Shared/quill-marking-logic/src/main';
import { requestPost, requestPut, } from '../../../../modules/request/index';
import {
  ALPHA_TRANSLATED_ACTIVITY_UIDS,
  CLICK,
  ENGLISH,
  KEYDOWN,
  KEYPRESS,
  LanguageSelectionPage,
  MOUSEDOWN,
  MOUSEMOVE,
  PlayFillInBlankQuestion,
  ProgressBar,
  SCROLL,
  VISIBILITYCHANGE,
  getParameterByName,
  languageToLocale,
  roundValuesToSeconds,
} from '../../../Shared/index';
import { ReadAloudContent } from '../../../Shared/components/readAloud/readAloudContent';
import { GRAMMAR } from '../../../Shared/utils/constants';
import { startListeningToConcepts } from '../../actions/concepts';
import * as conceptFeedbackActions from '../../actions/conceptsFeedback';
import * as fillInBlankConceptFeedbackActions from '../../actions/fillInBlankConceptsFeedback';
import { getActivity } from "../../actions/grammarActivities";
import * as questionActions from '../../actions/questions';
import * as fillInBlankQuestionActions from '../../actions/fillInBlankQuestions';
import * as responseActions from '../../actions/responses';
import {
  checkAnswer,
  getQuestions,
  getQuestionsForConcepts,
  goToNextQuestion,
  loadTranslatedQuestions,
  startListeningToFollowUpQuestionsForProofreaderSession,
  startNewSession,
  storeResponseInAttempts,
  updateSession,
} from "../../actions/session";
import { calculateScoreFromConceptResults, getConceptResultsForAllQuestions } from '../../helpers/conceptResultsGenerator';
import { extractResponse } from '../../helpers/extractResponse';
import { sumTimeTracking } from '../../../Shared/utils/liveViewAPIs';
import { LiveViewProgress, createLiveViewProgress, grammarAnsweredPrompts, promptStepTimeMs, questionFlowStage } from '../../../Shared/utils/liveViewProgress';
import { FormattedConceptResult, Question } from '../../interfaces/questions';
import { ConceptsFeedbackState } from '../../reducers/conceptsFeedbackReducer';
import { Spinner } from '../../../Shared/index';
import { GrammarActivityState } from '../../reducers/grammarActivitiesReducer';
import { SessionState } from '../../reducers/sessionReducer';

interface PlayGrammarContainerState {
  showTurkCode: boolean;
  saved: boolean;
  error: boolean;
  saving: boolean;
  introSkipped: boolean;
  startTime: number;
  isIdle: boolean;
  timeTracking: { [key:string]: number };
}

interface PlayGrammarContainerProps {
  grammarActivities: GrammarActivityState;
  conceptsFeedback: ConceptsFeedbackState;
  fillInBlankConceptsFeedback: any;
  concepts: any;
  session: SessionState;
  dispatch: Function;
  previewMode: boolean;
  questionToPreview: Question;
  questions: Question[];
  handleToggleQuestion: (question: Question) => void;
  skippedToQuestionFromIntro: boolean;
  isOnMobile: boolean;
  handleTogglePreviewMenu: () => void;
  updateLanguage: (language: string) => void;
  availableLanguages: string[];
  language?: string;
  translate: (language: string) => string;
}

export class PlayGrammarContainer extends React.Component<PlayGrammarContainerProps, PlayGrammarContainerState> {
  constructor(props: any) {
    super(props);

    this.state = {
      showTurkCode: false,
      saving: false,
      saved: false,
      error: false,
      introSkipped: false,
      startTime: Date.now(),
      isIdle: false,
      timeTracking: {}
    }

    const { dispatch, previewMode } = props
    dispatch(conceptFeedbackActions.startListeningToConceptsFeedback());
    dispatch(fillInBlankConceptFeedbackActions.startListeningToConceptsFeedback())
    dispatch(startListeningToConcepts());

    const proofreaderSessionId = getParameterByName('proofreaderSessionId', window.location.href)
    const sessionIdentifier = getParameterByName('student', window.location.href) || proofreaderSessionId
    const activityUID = getParameterByName('uid', window.location.href)
    dispatch(getActivity(activityUID))

    if (sessionIdentifier && !previewMode) {
      dispatch(questionActions.startListeningToQuestions(activityUID, sessionIdentifier));
      dispatch(fillInBlankQuestionActions.startListeningToQuestions(activityUID, sessionIdentifier));
    } else {
      dispatch(questionActions.startListeningToQuestions(activityUID));
      dispatch(fillInBlankQuestionActions.startListeningToQuestions(activityUID));
      dispatch(startNewSession())
    }

    if (proofreaderSessionId) {
      dispatch(startListeningToFollowUpQuestionsForProofreaderSession(proofreaderSessionId))
    }

    window.addEventListener(KEYDOWN, this.resetTimers)
    window.addEventListener(MOUSEMOVE, this.resetTimers)
    window.addEventListener(MOUSEDOWN, this.resetTimers)
    window.addEventListener(CLICK, this.resetTimers)
    window.addEventListener(KEYPRESS, this.resetTimers)
    window.addEventListener(SCROLL, this.resetTimers)
    window.addEventListener(VISIBILITYCHANGE, this.setIdle)
  }

  componentDidUpdate(prevProps) {
    const { timeTracking, introSkipped, saved, saving, } = this.state
    const { previewMode, questions, questionToPreview, grammarActivities, session, skippedToQuestionFromIntro, dispatch, handleToggleQuestion, language } = this.props;
    const { hasreceiveddata, currentActivity } = grammarActivities

    if (saved || saving) { return }

    const activityUID = getParameterByName('uid', window.location.href)

    if (prevProps.grammarActivities.hasreceiveddata !== hasreceiveddata && hasreceiveddata) {
      const { title, name, } = currentActivity
      document.title = `Quill.org | ${title || name}`
    }

    if (!hasreceiveddata && activityUID) {
      dispatch(getActivity(activityUID))
    }

    if (!_.isEqual(prevProps.session.timeTracking, session.timeTracking)) {
      this.setState({ timeTracking: session.timeTracking || timeTracking })
    }

    if (hasreceiveddata && grammarActivities.currentActivity && !session.hasreceiveddata && !session.pending && !session.error) {
      const { questions, concepts, flag } = grammarActivities.currentActivity
      if (questions && questions.length) {
        dispatch(getQuestions(questions, flag))
      } else {
        dispatch(getQuestionsForConcepts(concepts, flag))
      }
    }

    if (session.hasreceiveddata && !session.currentQuestion && session.unansweredQuestions.length === 0 && session.answeredQuestions.length > 0) {
      this.saveToLMS(session)
      // handles case where proofreader has no follow-up questions
    } else if (session.hasreceiveddata && !session.currentQuestion && session.unansweredQuestions.length === 0 && session.proofreaderSession) {
      this.saveToLMS(session)
    }

    const sessionID = getParameterByName('student', window.location.href)
    const proofreaderSessionId = getParameterByName('proofreaderSessionId', window.location.href)
    const sessionIdentifier = sessionID || proofreaderSessionId
    // eslint-disable-next-line react/destructuring-assignment
    if (sessionIdentifier && !_.isEqual(session, prevProps.session) && !session.pending && session.hasreceiveddata) {
      updateSession(sessionIdentifier, {...session, timeTracking, })
    }
    this.reportProgressToLiveView()
    if(previewMode && questions && session.currentQuestion && !questionToPreview) {
      const uid = session.currentQuestion.uid;
      const question = questions[uid];
      handleToggleQuestion(question);
    }
    if(previewMode && !introSkipped && skippedToQuestionFromIntro) {
      this.setState({ introSkipped: true });
    }
    if (hasreceiveddata && grammarActivities.currentActivity && session.hasreceiveddata && !session.pending && !session.error && language && language !== ENGLISH && !session.translated_questions) {
      dispatch(loadTranslatedQuestions(activityUID, language))
      dispatch(conceptFeedbackActions.loadTranslatedConceptsFeedback(language))
      dispatch(fillInBlankConceptFeedbackActions.loadTranslatedConceptsFeedback(language))
    }
  }

  componentWillUnmount() {
    if (this.liveViewProgress) { this.liveViewProgress.stop() }
    window.removeEventListener(KEYDOWN, this.resetTimers)
    window.removeEventListener(MOUSEMOVE, this.resetTimers)
    window.removeEventListener(MOUSEDOWN, this.resetTimers)
    window.removeEventListener(CLICK, this.resetTimers)
    window.removeEventListener(KEYPRESS, this.resetTimers)
    window.removeEventListener(SCROLL, this.resetTimers)
    window.removeEventListener(VISIBILITYCHANGE, this.setIdle)
  }

  private liveViewProgress: LiveViewProgress|null

  reportProgressToLiveView = () => {
    const { previewMode, session, } = this.props
    const sessionIdentifier = getParameterByName('student', window.location.href) || getParameterByName('proofreaderSessionId', window.location.href)
    if (!sessionIdentifier || previewMode || !session.hasreceiveddata) { return }

    if (!this.liveViewProgress) {
      this.liveViewProgress = createLiveViewProgress(sessionIdentifier, {
        totalPrompts: session.questionSet ? session.questionSet.length : null,
        getTimeSpentMs: () => {
          const { timeTracking, } = this.state
          return sumTimeTracking(timeTracking)
        },
        getStage: () => {
          const { session, } = this.props
          return questionFlowStage(this.determineActiveStepForTimeTracking(session), session.answeredQuestions)
        },
        getQuestionTimeSpentMs: () => {
          const { timeTracking, } = this.state
          const { session, } = this.props
          return promptStepTimeMs(this.determineActiveStepForTimeTracking(session), timeTracking)
        },
        getIdle: () => {
          const { isIdle, } = this.state
          return isIdle
        },
      })
    }

    this.liveViewProgress.sync(grammarAnsweredPrompts(session.answeredQuestions))
  }

  determineActiveStepForTimeTracking(session) {
    const { currentQuestion, answeredQuestions, } = session

    if (!currentQuestion) { return 'landing' }

    return `prompt_${answeredQuestions.length + 1}`
  }

    resetTimers = (e=null) => {
      const now = Date.now()
      this.setState((prevState, props) => {
        const { startTime, timeTracking, isIdle, inactivityTimer, } = prevState
        const { session, } = props
        const activeStep = this.determineActiveStepForTimeTracking(session)

        if (inactivityTimer) { clearTimeout(inactivityTimer) }

        let elapsedTime = now - startTime
        if (isIdle || !session.questionSet) {
          elapsedTime = 0
        }
        const newTimeTracking = {...timeTracking, [activeStep]: (timeTracking[activeStep] || 0) + elapsedTime}
        const newInactivityTimer = setTimeout(this.setIdle, 30000);  // time is in milliseconds (1000 is 1 second)

        return { timeTracking: newTimeTracking, isIdle: false, inactivityTimer: newInactivityTimer, startTime: now, }
      })

      return Promise.resolve(true);
    }

    setIdle = () => { this.resetTimers().then(() => this.setState({ isIdle: true })) }

    handleRetrySaveToLMSClick = () => {
      const { session } = this.props
      this.saveToLMS(session)
    }

    saveToLMS = (questions: SessionState) => {
      const { timeTracking, } = this.state
      const { session, previewMode } = this.props
      const { answeredQuestions } = questions
      const proofreaderSessionId = getParameterByName('proofreaderSessionId', window.location.href)
      const activityUID = getParameterByName('uid', window.location.href)
      const sessionID = getParameterByName('student', window.location.href)
      let results

      this.setState({ saving: true, })

      const data = { time_tracking: roundValuesToSeconds(timeTracking), }

      if (window.location.href.includes('turk')) {
        this.setState({showTurkCode: true})
      }
      if (proofreaderSessionId) {
        const { proofreaderSession } = session
        const proofreaderConceptResults = proofreaderSession.conceptResults
        const numberOfGrammarQuestions = answeredQuestions.length
        const numberOfProofreaderQuestions = proofreaderConceptResults.length
        const correctProofreaderQuestions = proofreaderConceptResults.filter(cr => cr.metadata.correct === 1)
        const proofreaderScore = correctProofreaderQuestions.length / numberOfProofreaderQuestions
        let proofreaderAndGrammarResults = proofreaderConceptResults
        let totalScore = proofreaderScore
        if (numberOfGrammarQuestions) {
          results = getConceptResultsForAllQuestions(answeredQuestions, numberOfProofreaderQuestions);
          const score = calculateScoreFromConceptResults(results);
          proofreaderAndGrammarResults = proofreaderConceptResults.concat(results)
          totalScore = ((proofreaderScore * numberOfProofreaderQuestions) + (score * numberOfGrammarQuestions)) / (numberOfGrammarQuestions + numberOfProofreaderQuestions)
        }
        if (proofreaderSession.anonymous) {
          const proofreaderActivityUID = proofreaderSession.activityUID
          this.createAnonActivitySession(proofreaderActivityUID, proofreaderAndGrammarResults, totalScore, data)
        } else if(!previewMode) {
          this.finishActivitySession(proofreaderSessionId, proofreaderAndGrammarResults, totalScore, data)
        }
      } else {
        results = getConceptResultsForAllQuestions(answeredQuestions);
        const score = calculateScoreFromConceptResults(results);
        if (sessionID && !previewMode) {
          this.finishActivitySession(sessionID, results, score, data);
        } else if (activityUID) {
          this.createAnonActivitySession(activityUID, results, score, data);
        }
      }
    }

    initializeSubscription(activitySessionUid) {
      if (window.postbuildEnv.NODE_ENV === 'development') {
        Pusher.logToConsole = true;
      }
      if (!window.pusher) {
        window.pusher = new Pusher(window.postbuildEnv.PUSHER_KEY, { cluster: window.postbuildEnv.PUSHER_CLUSTER });
      }
      const channel = window.pusher.subscribe(activitySessionUid);
      channel.bind('concept-results-saved', () => {
        document.location.href = `${window.postbuildEnv.DEFAULT_URL}/activity_sessions/${activitySessionUid}`;
        this.setState({ saved: true, });
      });

      channel.bind('concept-results-partially-saved', () => {
        document.location.href = window.postbuildEnv.DEFAULT_URL;
      });
    }

    finishActivitySession = (sessionID: string, results: FormattedConceptResult[], score: number, data) => {
      this.initializeSubscription(sessionID)

      requestPut(
        `${window.postbuildEnv.DEFAULT_URL}/api/v1/activity_sessions/${sessionID}`,
        {
          state: 'finished',
          concept_results: results,
          percentage: score,
          data
        },
        (body) => {
          // not doing anything here because Pusher should handle the redirect once the concept results are saved
        },
        (body) => {
          this.setState({
            saved: false,
            error: true,
          });
        }
      )
    }

    createAnonActivitySession = (lessonID: string, results: FormattedConceptResult[], score: number, data) => {
      const { showTurkCode, } = this.state;
      const { previewMode } = this.props;

      requestPost(
        `${window.postbuildEnv.DEFAULT_URL}/api/v1/activity_sessions/`,
        {
          state: 'finished',
          activity_uid: lessonID,
          concept_results: results,
          percentage: score,
          data
        },
        (body) => {
          if (!showTurkCode && !previewMode) {
            this.initializeSubscription(body.activity_session.uid)
          }
        }
      )
    }

    checkAnswer = (response: string, question: Question, responses: Response[], isFirstAttempt: Boolean) => {
      const { dispatch, } = this.props
      dispatch(checkAnswer(response, question, responses, isFirstAttempt))
    }

    goToNextQuestion = () => {
      const { dispatch, } = this.props
      this.resetTimers()
      dispatch(goToNextQuestion())
    }

    getCurrentQuestion = (showTranslation) => {
      const { session } = this.props
      if(!session?.currentQuestion) { return null }
      const { currentQuestion, translated_questions } = session
      const { key, uid } = currentQuestion
      let translation
      const keyOrUid = key || uid
      if (showTranslation && translated_questions && keyOrUid) {
        translation = translated_questions[keyOrUid]
      }
      // Ensure question has 'key' property for compatibility with shared components
      const normalizedQuestion = { ...currentQuestion, key: keyOrUid }
      if (translation) {
        return { ...normalizedQuestion, translation }
      }
      return normalizedQuestion;
    }

    submitFillInBlankResponse = (response: any) => {
      const { dispatch } = this.props
      // Only update session state - CMS save is handled by updateResponseResource
      // Pass the entire response object (which has structure { response: {...} })
      dispatch(storeResponseInAttempts(response))
    }

    updateFillInBlankResponseResource = (response: any, questionKey: string, attempts: any, dispatch: any) => {
      const latestAttempt = attempts ? attempts[attempts.length - 1] : undefined
      const isFirstAttempt = !latestAttempt
      dispatch(responseActions.saveResponseToCMS(extractResponse(response), isFirstAttempt))
    }

    renderFinishedSavingState = (showTranslation: boolean, languageLocale: string) => {
      const { translate } = this.props
      const { error } = this.state

      if (error) {
        return (
          <div className="landing-page">
            <h1>We couldn&apos;t save your activity session.</h1>
            <p>
              Your results could not be saved.<br />
              Make sure you are connected to the internet.<br />
              You can attempt to save again using the button below.<br />
              If the issue persists, ask your teacher to contact Quill.<br />
              Please provide the following URL to help us solve the problem.
            </p>
            <p><code style={{ fontSize: 14, }}>{window.location.href}</code></p>
            <button className="quill-button contained large primary focus-on-light" onClick={this.handleRetrySaveToLMSClick} type="button">Retry</button>
          </div>
        )
      }

      const translatedHeader = showTranslation ? <h1 lang={languageLocale}>{translate('Quill Grammar Completed^header')}</h1> : null
      const translatedMessage = showTranslation ? <p lang={languageLocale}>{translate('Quill Grammar Completed^message')}</p> : null

      return (
        <div className="landing-page">
          <h1>You&apos;ve completed the activity</h1>
          {translatedHeader}
          <p>Your results are being saved now. You&apos;ll be redirected automatically once they are saved.</p>
          {translatedMessage}
          <Spinner />
        </div>
      )
    }

    render(): JSX.Element {
      const proofreaderSessionId = getParameterByName('proofreaderSessionId', window.location.href)
      const { showTurkCode, saving, } = this.state
      const { dispatch, grammarActivities, session, concepts, conceptsFeedback, previewMode, questions, handleToggleQuestion, isOnMobile, handleTogglePreviewMenu, availableLanguages, updateLanguage, language, translate, fillInBlankConceptsFeedback, } = this.props
      const showTranslation = language && availableLanguages?.includes(language) && language !== ENGLISH
      const languageLocale = showTranslation ? languageToLocale[language] : ''
      const activityUID = getParameterByName('uid', window.location.href)
      if (showTurkCode) {
        return <TurkCodePage />
      }

      if ((grammarActivities.hasreceiveddata || proofreaderSessionId) && session.hasreceiveddata) {

        if (session.currentQuestion) {
          const activity = grammarActivities ? grammarActivities.currentActivity : null
          const isFillInBlankActivity = activity?.questionType === 'fillInBlank'

          if (isFillInBlankActivity) {
            const isLastQuestion = session.unansweredQuestions.length === 0
            const answeredQuestionCount = session.answeredQuestions.length + 1
            const totalQuestionCount = answeredQuestionCount + session.unansweredQuestions.length
            const meterWidth = answeredQuestionCount / totalQuestionCount * 100

            return (
              <div className="question fill-in-blank-question">
                <div className="top-section">
                  <ProgressBar
                    answeredQuestionCount={answeredQuestionCount}
                    label="questions"
                    percent={meterWidth}
                    questionCount={totalQuestionCount}
                  />
                  <ReadAloudContent label="Read the title aloud"><h1>{activity ? activity.title || activity.name : null}</h1></ReadAloudContent>
                </div>
                <div className="student-container student-container-diagnostic">
                  <PlayFillInBlankQuestion
                    concepts={concepts}
                    conceptsFeedback={fillInBlankConceptsFeedback}
                    dispatch={dispatch}
                    FeedbackContainer={FeedbackContainer}
                    getGradedResponsesWithCallback={responseActions.getGradedResponsesWithCallback}
                    isLastQuestion={isLastQuestion}
                    language={language}
                    languageLocale={languageLocale}
                    mode={GRAMMAR}
                    nextQuestion={this.goToNextQuestion}
                    previewMode={previewMode}
                    question={this.getCurrentQuestion(showTranslation)}
                    showTranslation={showTranslation}
                    submitResponse={this.submitFillInBlankResponse}
                    translate={translate}
                    updateResponseResource={this.updateFillInBlankResponseResource}
                  />
                </div>
              </div>
            )
          }

          return (
            <QuestionComponent
              activity={activity}
              answeredQuestions={session.answeredQuestions}
              availableLanguages={availableLanguages}
              checkAnswer={this.checkAnswer}
              concepts={concepts}
              conceptsFeedback={conceptsFeedback}
              dispatch={dispatch}
              goToNextQuestion={this.goToNextQuestion}
              handleTogglePreviewMenu={handleTogglePreviewMenu}
              handleToggleQuestion={handleToggleQuestion}
              isOnMobile={isOnMobile}
              language={language}
              languageLocale={languageLocale}
              previewMode={previewMode}
              question={this.getCurrentQuestion(showTranslation)}
              questions={questions}
              questionSet={session.questionSet}
              showTranslation={showTranslation}
              translate={translate}
              translatedQuestions={session?.translated_questions}
              unansweredQuestions={session.unansweredQuestions}
            />
          )
        }
        if (saving) { return this.renderFinishedSavingState(showTranslation, languageLocale) }
        if (!grammarActivities && !proofreaderSessionId) { return <Spinner /> }

        if (!session?.language && availableLanguages?.length > 1 && !language && !ALPHA_TRANSLATED_ACTIVITY_UIDS.includes(activityUID)) {
          return (
            <LanguageSelectionPage
              dispatch={dispatch}
              languages={availableLanguages}
              previewMode={previewMode}
              setLanguage={updateLanguage}
            />
          );
        }

        return(
          <Intro
            activity={grammarActivities.currentActivity}
            availableLanguages={availableLanguages}
            language={session?.language}
            previewMode={previewMode}
            session={session}
            startActivity={this.goToNextQuestion}
            translate={translate}
          />
        )
      }

      if (session.error) {
        return (
          <div>{session.error}</div>
        );
      }

      return <Spinner />
    }
}

const mapStateToProps = (state: any) => {
  return {
    grammarActivities: state.grammarActivities,
    session: state.session,
    conceptsFeedback: state.conceptsFeedback,
    fillInBlankConceptsFeedback: state.fillInBlankConceptsFeedback,
    concepts: state.concepts,
    questions: state.questions.data,
    fillInBlank: state.fillInBlank.data,
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>) => {
  return {
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayGrammarContainer);
